<!-- 零售-订单明细-匹配赠品挂靠关系 -->
<template>
  <div class="cus-modal" v-loading="loading">
    <OmsTable
      :jordan-table-config="tableConfig"
      @on-row-click="onSelect"
      @on-row-dblclick="onSelect"
    />
    <div style="padding-top:12px;">
      <span>商品SKU：</span>
      <Input v-model="proSku" placeholder="请输入商品SKU" style="width: 300px"/>
      <span style="color: red;padding-left:12px;">* 允许直接输入不在本单内的主品物料号。</span>
    </div>
    <OmsButton class="modal-footer" :btn-config="btnConfig" />
  </div>
</template>
<script>

export default {
  name: 'matchGiftRely',
  props: {
    componentData: {
      type: Object,
      default: {},
    }
  },
  data() {
    return {
      proSku: '',
      loading: false,
      tableConfig: {
        indexColumn: true, // 是否显示序号
        isShowSelection: true, // 是否存在多选
        pageShow: false, // 控制分页是否显示
        searchInputShow: false, // 控制搜索框是否显示
        highlightRow: true, // 高亮单选必须结合它
        multiple: false,
        width: '', // 表格宽度
        height: '350',
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10, // 默认每页条数100条，产品要求
        selectionData: [], // 勾选数据
        data: [],
        columns: [
          {
            key: 'PS_C_PRO_ECODE',
            title: t('SPU编码'),
          },
          {
            key: 'PS_C_SKU_ECODE',
            title: t('条码'),
          },
          {
            key: 'PS_C_PRO_ENAME',
            title: t('SKU名称'),
          },
          {
            key: 'QTY',
            title: t('购买数量'),
          },
        ]
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right',
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            loading: false,
            btnclick: () => {
              this.submit();
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/order/select', { id: this.componentData.orderId }).then(res => {
        if (res.data.code == 0) {
          this.tableConfig.data = res.data.data || []
        }
      }).finally(() => this.loading = false)
    },
    submit() {

      if (!this.tableConfig.selectionData.length && !this.proSku) {
        return $fcError(t('请选中一项，或输入商品SKU！'))
      }
      this.loading = true
      const params = {
        proSku: this.proSku,
        giftIds: this.componentData.giftIds,
        itemId: this.tableConfig.selectionData.length ? this.tableConfig.selectionData[0].ID : ''
      }
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/giftRely/match', params).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message)
          this.$parent.$parent.closeConfirm();
        }
      }).finally(() => this.loading = false)
    },
    onSelect(selection) {
      this.tableConfig.selectionData = [selection];
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ #dropMultiSelectFilter {
  .ark-input {
    color: #515a6e;
  }
}
/deep/ .ark-table td {
  .ark-input {
    height: 26px;
  }
}
</style>
